import {
  Checkbox,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  FormControl,
  InputLabel
} from "@mui/material";
import React, { useEffect, useState } from "react";

function MultiSelect(props) {
  const [mainList, setMainList] = useState([]);

  useEffect(() => {
    const uniqueValues = new Set();
    const domainKeys = Array.isArray(props.domainKey)
      ? props.domainKey
      : [props.domainKey];

    domainKeys.forEach((key) => {
      const matchingDomains =
        props.domainDetails[key]?.map((d) => d.domainValue) || [];
      matchingDomains.forEach((domainValue) => {
        uniqueValues.add(domainValue);
      });
    });

    const updatedMainList = ["All", ...uniqueValues];
    setMainList(Array.from(updatedMainList));

    const { searchObj, searchObjField, setSearchObj } = props;
    if (!searchObj?.[searchObjField]) {
      setSearchObj({
        ...searchObj,
        [searchObjField]: updatedMainList,
      });
    }
  }, []);

  const handleChangeMultiSelect = (e) => {
    const selectedValues = e.target.value;
    const searchObj = { ...props.searchObj };
    if (Array.isArray(selectedValues)) {
      if (selectedValues.length === 1 && selectedValues.includes("AllValue")) {
        if (!searchObj[props.searchObjField]?.includes("All")) {
          searchObj[props.searchObjField] = mainList;
        }
      } else if (selectedValues.includes("AllValue")) {
        searchObj[props.searchObjField] = [];
      } else {
        if (
          !selectedValues.includes("All") &&
          !selectedValues.includes("AllValue") &&
          selectedValues.length === mainList.length - 1
        ) {
          searchObj[props.searchObjField] = mainList;
        } else {
          const updtSelectedValues = selectedValues.filter(
            (item) => item !== "All" && item !== "AllValue"
          );
          searchObj[props.searchObjField] = updtSelectedValues;
        }
      }
    } else {
      searchObj[props.searchObjField] = [];
    }
    props.setSearchObj(searchObj);
  };

  const getMenuItemImpl = () => {
    let menuItemList = [
      <MenuItem dense key="All" value="AllValue">
        <Checkbox
          checked={
            props.searchObj?.[props.searchObjField]?.length === mainList.length
          }
          indeterminate={
            props.searchObj?.[props.searchObjField]?.length > 0 &&
            props.searchObj?.[props.searchObjField]?.length < mainList.length
          }
        />
        <ListItemText primary={"All"} />
      </MenuItem>,
    ];

    const domainKeys = Array.isArray(props.domainKey)
      ? props.domainKey
      : [props.domainKey];

    const uniqueDomainValues = new Set();
    const domainItems = domainKeys.flatMap((key) => {
      return (props.domainDetails[key] || []).map((domain) => {
        if (!uniqueDomainValues.has(domain.domainValue)) {
          uniqueDomainValues.add(domain.domainValue);
          return (
            <MenuItem
              dense={true}
              key={domain.domainValue}
              value={domain.domainValue}
            >
              <Checkbox
                checked={
                  Array.isArray(props.searchObj?.[props.searchObjField]) &&
                  props.searchObj[props.searchObjField].includes(
                    domain.domainValue
                  )
                }
              />
              <ListItemText primary={domain.domainValue} />
            </MenuItem>
          );
        }
        return null;
      });
    });

    return [...menuItemList, ...domainItems];
  };

  return (
    <>
      <FormControl sx={{ m: 1, width: "100%" }} size="small">
        <InputLabel id={`${props.searchObjField}-multiple-checkbox-label`}>
          {props.texts[props.transKey]}
        </InputLabel>
        <Select
          labelId={`${props.searchObjField}-multiple-checkbox-label`}
          id={`${props.searchObjField}--multiple-checkbox`}
          multiple
          value={props.searchObj?.[props.searchObjField] ?? []}
          onChange={handleChangeMultiSelect}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (
              !selected ||
              selected.length === 0 ||
              (props.searchObj &&
                props.searchObj[props.searchObjField]?.includes("All"))
            ) {
              return "All";
            }
            return selected.join(", ");
          }}
          MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
        >
          {getMenuItemImpl()}
        </Select>
      </FormControl>
    </>
  );
}

export default MultiSelect;
